import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is a web portal service?",
    answer: `<h4>Web Portals Focus on Personalized Access</h4><p>A web portal is a website that offers a wide range of services, including search engines, email, online shopping, and discussion forums.</p>`,
  },
  {
    question: "What is the difference between a web service and a web portal?",
    answer: `<p>While websites deliver general information, web portals cater to specific user groups by providing access to a variety of services and data. Web portals come in many forms, including client and vendor portals, as well as corporate intranets and extranets.</p>`,
  },
  {
    question: "What is the main purpose of the web portal?",
    answer: ` <p>Web portals are created to offer a centralized access point to diverse information and services, often tailored to individual users. They are usually limited to a specific user group, such as employees, customers, or organizational members.</p>`,
  },
  {
    question: "When will I be able to use the web portal?",
    answer: `<p>When you purchase a COTS web portal, you can typically start using and setting it up right away. However, your organization will need to handle the setup manually and address any issues.</p>
    <p>Additionally, you won't have control over code bugs or restricted integrations. In contrast, while a custom solution may require several months of development, these concerns are eliminated, ensuring seamless operations once development is finished.</p>`,
  },
  {
    question: "Will my web portal integrate with my existing software?",
    answer: `<p>With a COTS web portal, your integration options are generally restricted to software developed by the same SaaS provider or your partners. In contrast, investing in custom web portal development allows your portal to integrate with any existing software, regardless of the developer.</p>
    <p>It also simplifies the integration process for any new applications and software developed after the portal is delivered.</p>`,
  },
  {
    question: "How do you ensure the security of a web portal?",
    answer: ` <p>Securing a web portal entails several measures like: implementing SSL/TLS for data encryption, utilizing secure authentication methods like OAuth and two-factor authentication, keeping software and plugins updated, performing regular security audits and vulnerability assessments, and applying role-based access control (RBAC) to limit access appropriately.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Web Portal FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
